import { useEffect } from 'react'
import { FieldValues, UseFormReset } from 'react-hook-form'
import { parseISO } from 'libs/dates'
import { OpeningHourItem } from 'features/openingHours/types/openingHours.types'

type UsePopulateOpeningHourProps = {
	data: OpeningHourItem | undefined
	reset: UseFormReset<FieldValues>
}

export const usePopulateOpeningHour = ({ data, reset }: UsePopulateOpeningHourProps) => {
	useEffect(() => {
		if (data) {
			reset({
				is_open: data.is_open,
				is_bookable: data.is_bookable,
				counts_towards_duration: data.counts_towards_duration,
				reason: data.reason,
				date: parseISO(data.date)
			})
		}
	}, [data])
}
